module.exports = __webpack_public_path__ + "static/media/no-content.8f67c7da.svg";